<template>
  <div class="navigation-wrapper sticky" ref="navigation" :class="{ transparent: transparent }">
    <nav class="navigation">
      <div class="title">
        <slot name="title"></slot>
      </div>
      <Menu :onClick="showNavi" v-if="showMenu" ref="menu"></Menu>
      <!-- <div class="menu">
      </div>-->
      <div class="modal" :class="{ios: isIos()}" v-if="show" ref="modal" @scroll.stop="onScroll">
        <div class="modal__title">
          <router-link to="/">Home</router-link>
          <div class="close-button" @click="close"></div>
        </div>
        <div class="category">
          <div class="category-item" 
          v-for="(item, i) in linkList" :key="i">
            <div>
              <h3 class="category-title">{{ item.title }}</h3>
            </div>
            <div>
              <router-link
                v-for="(box,i) in item.list"
                :key="i"
                :to="`${routePaths.categories}/${box.url}`"
                class="box-item"
                :class="{ active: isActiveNavi(box) }"
              >{{ box.nav }}</router-link>
              <div class="category-border" v-if="i !== linkList.length - 1"></div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Menu from "./Menu";
import { CategoryLists } from "@/models/CategoryKey";
// import { categories } from "@/models/categories";
import { routePaths } from "@/models/RoutePath";
export default {
  props: {
    transparent: {
      type: Boolean,
      default: () => false,
    },
    showMenu: {
      type: Boolean
    }
  },
  components: {
    Menu,
  },
  data() {
    return {
      routePaths,
      // linkList: [
      //   {
      //     category: categories[CategoryKey.Serif].cover.caption,
      //     categoryLink: CategoryKey.Serif,
      //     list: categories[CategoryKey.Serif].box.list,
      //   },
      //   {
      //     category: categories[CategoryKey.Sero].cover.caption,
      //     categoryLink: CategoryKey.Sero,
      //     list: categories[CategoryKey.Sero].box.list,
      //   },
      //   {
      //     category: categories[CategoryKey.Frame].cover.caption,
      //     categoryLink: CategoryKey.Frame,
      //     list: categories[CategoryKey.Frame].box.list,
      //   },

      // // Serif.ModelKey.Serif02,
      // Serif.ModelKey.Serif03,
      // Serif.ModelKey.Serif04,
      // ],
      linkList: CategoryLists,
      show: false,
      scrollPosition: 0,
      params: "",
    };
  },
  methods: {
    isActiveNavi(box) {
      return (
        box.url === this.$route.params.category ||
        box.url === this.$route.params.categoryKey
      );
    },
    showNavi() {
      if (this.show) {
        return;
      }
      this.show = true;
      if (this.detectMob()) {
        const $body = document.body;
        this.scrollPosition = window.pageYOffset;
        $body.style.overflow = "hidden";
        $body.style.position = "fixed";
        $body.style.top = `-${this.scrollPosition}px`;
        $body.style.width = "100%";
      }
    },
    close() {
      this.show = false;
      if (this.detectMob()) {
        const $body = document.body;
        $body.style.removeProperty("overflow");
        $body.style.removeProperty("position");
        $body.style.removeProperty("top");
        $body.style.removeProperty("width");
        window.scrollTo(0, this.scrollPosition);
      }
    },
    onOutsideClick(e) {

      if(this.$refs.menu == undefined){
        return;
      }

      if (!this.$refs.menu.$el.contains(e.target) && this.$refs.modal &&!this.$refs.modal.contains(e.target) ) {
        this.close();
      }
    },
    onScroll(e) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    },
    detectMob() {
      return window.innerWidth <= 1024;
    },
    isIos() {
      return (
        /iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
      );
    },
  },
  mounted() {
    document.body.addEventListener("click", this.onOutsideClick);
    // Sticky.addOne(this.$refs.navigation);
  },
  destroyed() {
    this.close();
    document.body.removeEventListener("click", this.onOutsideClick);
  },
};
</script>

<style scoped>
.navigation-wrapper {
  background-color: black;
  height: 128px;
  width: 100%;
  z-index: 999;
  position: fixed;
  top: 0;
  /* position: relative; */
}
.navigation {
  max-width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  position: relative;
}

.title {
  font-weight: 500;
}

.modal {
  position: absolute;
  width: 229px;
  /* height: 300px; */
  background-color: white;

  right: 40px;
  top: 100%;
  border-radius: 30px;
  color: #111111;
  border-color:#333333;
  padding: 20px 10px 0px 48px;
  text-align: left;
  font-weight: 700;
  max-height: calc(100vh - 54px - 70px);
  overflow-y: auto;
  box-sizing: border-box;
  overscroll-behavior: touch;
  -webkit-overflow-scrolling: auto;
  /* scroll-padding: 50px 50px 50px 50px; */

  box-shadow: 20px 0px 0px 0px FFFFFF;
}
.modal::-webkit-scrollbar-thumb
{
  width: 5px; 
  height: 8px; 
  border: 3px solid #aaaaaa;
  }

.modal.ios::-webkit-scrollbar {
  display: none;
}
/* .modal.ios {

  padding-right: 20px;
  box-shadow: 0px 0px 0px 0px white;
} */

/* .modal::-webkit-scrollbar-thumb {
  width: 0;
  background-color: white !important;
  display: inline-block;
} */

.modal .modal__title {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
}
.modal .close-button {
  display: inline-block;
  width: 12px;
  height: 12px;
  position: relative;
  cursor: pointer;
}
.modal .close-button::before {
  width: 12px;
  border-top: 2px solid #aaaaaa;
  content: " ";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
}
.modal .close-button::after {
  width: 12px;
  border-top: 2px solid #aaaaaa;
  content: " ";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) rotate(-45deg);
}
.modal .category {
  margin-top: 36px;
  padding-bottom: 40px;
}
.modal .category-title {
  /* margin-top: 20px; */
  display: inline-block;
  letter-spacing: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 0.87;
}

.modal .box-item {
  color: #aaaaaa;
  font-family: "SamsungOne";
  font-weight: 700;
  font-size: 12px;
  margin-top: 12px;
  letter-spacing: 0;
  /* margin-bottom: 12px; */
  display: block;
}
.modal .category-border {
  height: 1px;
  background-color: #aaaaaa;
  width: 158px;
  margin: 20px 0;
}

.modal .box-item.active {
  color: #111111;
}
.category-item {
  overflow: visible;
}

@media (max-width: 360px) {
  .navigation-wrapper {
    height: 54px;
    background-color: #111111;
    /* padding: 0 20px; */
  }
  .navigation {
    padding: 0 20px;
  }
  .title {
    font-size: 1.33rem;
  }
}
@media (min-width: 360px) {
  .navigation-wrapper {
    height: 54px;
    /* padding: 0 20px; */
    background-color: #111111;
  }
  .navigation {
    padding: 0 20px;
  }
  .title {
    font-size: 1.33rem;
  }
}
@media (min-width: 1024px) {
  .navigation-wrapper {
    height: 128px;
    background-color: #000000;
    transition: all 0.3s;
  }
  .navigation-wrapper.transparent {
    /* height: 128px; */
    background-color:rgb(0,0,0,0);
  }
  .title {
    font-size: 2.57rem;
    font-weight: 700;
  }
  .modal {
    width: 360px;
    padding: 26px 24px 0 72px;
    box-sizing: border-box;
    max-height: calc(100vh - 128px - 50px);
    overflow: auto;
    box-shadow: 25px 0px 0px 0px FFFFFF;
  }
  .modal .modal__title,
  .modal .category-title {
    font-size: 24px;
  }
  .modal .category {
    padding-bottom: 60px;
  }
  .modal .box-item {
    font-size: 16px;
  }
  .modal .close-button {
    width: 18px;
    height: 18px;
  }
  .modal .close-button::after {
    width: 18px;
  }
  .modal .close-button::before {
    width: 18px;
  }
  .modal .category-border {
    width: 235px;
    /* margin: 20px 0; */
  }
}
</style>
